module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "collumns"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/diego-makarausky/"
    }
  }, [_c('img', {
    staticClass: "circle bordabranca",
    attrs: {
      "src": require("../assets/img/diego.jpeg")
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/diego-makarausky/"
    }
  }, [_vm._v("Diego Makarausky")])]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Senior Product Manager")]), _vm._v(" "), _c('h5', [_vm._v(" ⭐⭐⭐⭐⭐ ")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_c('i', [_vm._v("\"Juscilan is a very talented Senior Engineer, very skilled, committed and helpful. \n                  You can always count that whatever is assigned to him will be delivered with high quality. \n                  I totally recommend Juscilan to any team who needs a great Senior Back-end Developer.\"\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/denise-calsavara-paiva-de-oliveira/"
    }
  }, [_c('img', {
    staticClass: "circle bordabranca",
    attrs: {
      "src": require("../assets/img/denise.jpeg")
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/denise-calsavara-paiva-de-oliveira/"
    }
  }, [_vm._v("Denise Oliveira")])]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Tech Lead | Senior Frontend Developer | Angular")]), _vm._v(" "), _c('h5', [_vm._v(" ⭐⭐⭐⭐⭐ ")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_c('i', [_vm._v("\"Juscilan was an awesome co-worker and helped me a lot with backend stuff while I was Tech Lead. He was not afraid of handling the mosts difficult tasks. \n                  He is good on dive in, talk to people and do whatever is needed to solve a problem. I wish we could work longer together\"\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/natalia-cudna-5a72329a/"
    }
  }, [_c('img', {
    staticClass: "circle bordabranca",
    attrs: {
      "src": require("../assets/img/natalia.jpeg")
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/natalia-cudna-5a72329a/"
    }
  }, [_vm._v("Natalia Cudna")])]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Senior Scrum Master | Agile Coach | PSM II | SPS")]), _vm._v(" "), _c('h5', [_vm._v(" ⭐⭐⭐⭐⭐ ")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_c('i', [_vm._v("\"Juscilan is a good teammate - he adapted to the team very quickly. He learned new things fast and were able to start implementing value quickly. \n                  He was able to work on more problematic and complex problems also - both individually and in parallel with another programmer. \n                  Developers enjoyed working with him and me too.\"\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/dannielhugo/"
    }
  }, [_c('img', {
    staticClass: "circle bordabranca",
    attrs: {
      "src": require("../assets/img/danniel.jpeg")
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/dannielhugo/"
    }
  }, [_vm._v("Danniel Ribeiro")])]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Senior Frontend Developer")]), _vm._v(" "), _c('h5', [_vm._v(" ⭐⭐⭐⭐⭐ ")]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_c('i', [_vm._v("\"Although we only had a limited amount of time to work together, Juscilan and I worked together in the same team for the past few months. \n                  Juscilan showed really good back-end-related skills, such as knowing how to make processes faster, reliable, and fault-proof.\"\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/arleen-silva/"
    }
  }, [_c('img', {
    staticClass: "circle bordabranca",
    attrs: {
      "src": require("../assets/img/arleen.jpeg")
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/arleen-silva/"
    }
  }, [_vm._v("Arleen Silva")])]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Developer")]), _vm._v(" "), _c('h5', [_vm._v(" ⭐⭐⭐⭐⭐ ")]), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_c('i', [_vm._v("\"Juscilan arrive in the team and quickly learn how the flow worked to help the team. \n                  No matter the issue, he would pick an issue and did what it needs to be resolved. Totally recommends Juscilan.\"\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('h2', {
    staticClass: "center black-text"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/luiscontrerasm/"
    }
  }, [_c('img', {
    staticClass: "circle bordabranca",
    attrs: {
      "src": require("../assets/img/luis.jpeg")
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/luiscontrerasm/"
    }
  }, [_vm._v("Luis Contreras")])]), _vm._v(" "), _c('h6', {
    staticClass: "bold"
  }, [_vm._v("Full Stack Engineer | Angular | NestJS | TypeScript | JavaScript")]), _vm._v(" "), _c('h5', [_vm._v(" ⭐⭐⭐⭐⭐ ")]), _vm._v(" "), _c('h5', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "light"
  }, [_c('i', [_vm._v("\"Juscilan is a great teammate, always open to receive questions and to offer help. \n                  He's very professional and have a lot of knowledge in javascript.\"\n                ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ab24ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-d-collumns.vue
// module id = 418
// module chunks = 1